import React from "react";
import styles from "../assets/css/imageBanner.module.scss";
import {Container, Typography} from "@mui/material";


const ImageBanner = (props) => {
    return <div className={styles.container}>
        <img src={props.image} alt={""}/>
        <div>
            <Container maxWidth={"xl"} component={"div"}>
                <Typography variant={"h4"} component={"h4"}>
                    {props.title}
                </Typography>

            </Container>
        </div>

    </div>;
};

export default ImageBanner;